import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { computed, inject, Injectable, signal } from "@angular/core";
import { environment } from "../../../environments/environment";

import { catchError, Observable, of } from "rxjs";
import { StorageService } from "./storage.service";
import { AuthEndPoints } from '../../feature/Enums/authApis.Endpoints';

@Injectable({
  providedIn: "root",
})
export class LoginService {
  _httpClient = inject(HttpClient);
  _storageService = inject(StorageService);
  baseUrl = environment.apiUrl;
  token = signal<string | null>(this._storageService.getSessionStorageValue("token"))
  isLoggedIn = computed(() => !!this.token());

  login(data: any): Observable<any> {
    return this._httpClient.post(`${this.baseUrl}${AuthEndPoints.Login}`, data).pipe(
      catchError((error: HttpErrorResponse | any) => {
        return of({
          status: error.status,
          msg: error.error.msg,
        });
      })
    );
  }


}
